import { render, staticRenderFns } from "./remindSet.vue?vue&type=template&id=31ce139e&scoped=true&"
import script from "./remindSet.vue?vue&type=script&lang=js&"
export * from "./remindSet.vue?vue&type=script&lang=js&"
import style0 from "./remindSet.vue?vue&type=style&index=0&id=31ce139e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce139e",
  null
  
)

export default component.exports